/*
* Text Input Component
* */
import React, { useEffect, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {randomIdentifier} from "../../../utils/helpers";

type Props = {
    label: String,
    isRequired: boolean,
    errorMsg: any,
    placeHolder: String,
    id: string,
    name: string,
    value: String,
    handleChange: Function,
    handleFocus: Function,
    handleBlur: Function,
    handleClick: Function,
    handleKeyDown: Function,
    btnClass: String,
    btnLabel: String,
    btnHandleClick: Function,
    appendContent: any,
    disabled: boolean,
    readonly: boolean,
    pattern: String,
    type: String,
    autoComplete : String,
    maxLength : String,
    showCountLength: Boolean,
    sublabel: String
};


const TextInputComponent = ({
                                label,
                                isRequired,
                                errorMsg,
                                placeHolder,
                                id,
                                name,
                                value,
                                handleChange,
                                handleFocus,
                                handleBlur,
                                handleClick,
                                btnClass,
                                btnLabel,
                                btnHandleClick,
                                appendContent,
                                disabled,
                                readonly,
                                pattern,
                                type,
                                autoComplete,
                                maxLength,
                                handleKeyDown,
                                showCountLength,
                                sublabel
                            }: Props) => {

    const [text, setText] = useState(value);
    useEffect(() => {
        setText(value);
    }, [value])

    const _handleChange = (e) => {
        if(typeof handleChange == 'function') handleChange(e)
        setText(e.target.value)
    }

    return (
        <div className="input-component">
            <label className={(isRequired) ? "required" : ''}>{label}</label>
            {
                sublabel && <div className='sub-label'>{sublabel}</div>
            }
            <div className="input-group">
                <input 
                       className={errorMsg.length == 0 ? "form-control": "form-control form-control-error"}
                       placeholder={placeHolder}
                       value={value}
                       id={id}
                       name={name}
                       onChange={_handleChange}
                       onBlur={handleBlur}
                       onClick={handleClick}
                       onFocus={handleFocus}
                       onKeyDown={handleKeyDown}
                       readOnly={readonly}
                       disabled={disabled}
                       pattern={pattern}
                       type={type}
                       autoComplete={autoComplete}
                       maxLength={maxLength}
                />
                {showCountLength && <label className='count-length'><span className='current-length'>{value.length}</span>/{maxLength}</label>}
                {(btnLabel.length == 0) ? "" :
                    <button type="button" className={btnClass} onClick={btnHandleClick}>{btnLabel}</button>
                }
                {!appendContent ? "" : appendContent}
            </div>
            {errorMsg.length == 0 ? "" :
                <span className="input-error show">{errorMsg}</span>
            }
        </div>
    );
};

TextInputComponent.defaultProps = {
    isRequired: false,
    btnHandleClick: ()=>{},
    handleChange: ()=>{},
    handleFocus: ()=>{},
    handleBlur: ()=>{},
    handleClick: ()=>{},
    handleKeyDown: ()=>{},
    value: "",
    id: "js-"+ randomIdentifier(),
    name: "input-"+ randomIdentifier(),
    errorMsg: "",
    placeHolder: "",
    btnClass: "",
    btnLabel: "",
    appendContent: false,
    disabled: false,
    readonly: false,
    type: 'text',
    autoComplete : 'on',
    maxLength : "255",
    showCountLength: false,
    sublabel: ''
};

export default memo(TextInputComponent);
